import React from 'react'
import { Field, Form, Formik } from 'formik'
import { TextField, Button } from '@material-ui/core'
import AuthService from '../services/AuthService'
import "../styles/AdminNewPass.css"
// import {Link} from "react-router-dom";
import {useHistory} from 'react-router-dom'


function  AdminNewPass() {
    const history = useHistory();
    const iniVal = {
        pass: '',
        cpass:''
    }

    const handleNewPass = (values) => {
        console.log(values,"lllllllllllyyyyyyyyyy")
        if(values.pass === '' && values.cpass ==='' ){
            alert('You need to Provide passwords')
        }
        else{
            AuthService.newPassword(values.pass, values.cpass).then(res => {
                if(res === "Password Set Successfully!"){
                    // history.push('/admin/dashboard');

                    history.push('/login')

                }
                })
        }
    }
    return (
        <div className="newPassMains">
            <div className="newpassContainers">
                <h4>Set Your New Password</h4>
                <Formik initialValues={iniVal} onSubmit={handleNewPass}>
                    {
                        () => (
                            <Form>
                                <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                    <Field name="pass" as={TextField}  label="Password" variant="outlined" type="password" />
                                    <Field name="cpass" as={TextField}  label="Confirm Password" variant="outlined" type="password"/>
                                    <Button variant="contained" color="primary" type="submit">submit password</Button>
                                    {/* <Link className="link" to={"/send_OTP"}><Button variant="contained" color="primary">OTP</Button></Link> */}
                                    {/* <Button onClick={() => history.push('/admin/dashboard')} color="secondary" autoFocus>hj</Button> */}

                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </div>
    )
}

export default AdminNewPass
